var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMark = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 8,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.194.358L4.418 5.134 2.03 2.746a1.154 1.154 0 0 0-1.672 0 1.154 1.154 0 0 0 0 1.672l3.224 3.224c.239.239.478.358.836.358s.597-.12.836-.358l5.612-5.612a1.154 1.154 0 0 0 0-1.672 1.154 1.154 0 0 0-1.672 0z",
  fill: "#005FF9",
  fillRule: "evenodd"
})));
export { SvgMark as ReactComponent };